import type { Enterprise } from '@pn/core/domain/enterprise';
import { assert } from '@pn/core/utils/assert';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isFetching: false,
  isError: false,
  enterprise: undefined as Enterprise | undefined,
};

const createEnterpriseSlice = (sliceName: string) =>
  createSlice({
    name: sliceName,
    initialState,
    reducers: {
      request: (state) => {
        state.isFetching = true;
        state.isError = false;
      },
      receive: (state, { payload }: PayloadAction<Enterprise>) => {
        state.isFetching = false;
        state.enterprise = payload;
      },
      error: (state) => {
        state.isFetching = false;
        state.isError = true;
      },
      update: (
        state,
        { payload }: PayloadAction<{ crs: Enterprise['crs'] }>
      ) => {
        assert(state.enterprise, 'Enterprise must be defined');
        state.enterprise = { ...state.enterprise, ...payload };
      },
    },
  });

export const currentEnterpriseSlice =
  createEnterpriseSlice('currentEnterprise');
